import USERS_QUERY from '@xem/user-common/graphql/UserByEmail.graphql'
import { withContentCallback } from '@xem/entity/classes/preloadContents';

export default function userEmail(name: string){
	return withContentCallback(((res: any)=> res), name, USERS_QUERY)
}